<section class="layout">
    <div class="divcolumn1">
        <mat-panel-title class="title">
            Our food offerings for a {{eventName}}
        </mat-panel-title>
        <div class="example-ripple-container mat-elevation-z4" matRipple *ngFor="let item of foodtype"
            (click)="LoadMenu(item)">
            <img mat-card-image class="ripple-image" [src]="item.image" alt="{{item.text}}">
            <mat-panel-title class="titlebox">
                {{item.text}}
            </mat-panel-title>
            <mat-panel-title class="title">Item Count: {{item.itemcount}}</mat-panel-title>
        </div>
    </div>
    <div class="divcolumn2">
        <mat-panel-title class="title">
            Our selection of {{selectedtype}}
        </mat-panel-title>
        <mat-accordion *ngFor="let item of welcomedrink">
            <div class="card">
                <div class="left">
                    <mat-expansion-panel class="panel">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                {{item.foodname}}
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <img mat-card-image [src]="item.foodimage" alt="{{item.text}}" class="panelimage">
                        <p>{{item.fooddesc}}</p>
                    </mat-expansion-panel>
                </div>
                <div class="right">
                    <button mat-icon-button (click)="addToMenu(item)">
                        <mat-icon inline="false" class="btn-iconwhite">add</mat-icon>
                    </button>

                </div>
            </div>
        </mat-accordion>
    </div>
    <div class="divcolumn3">
        <div>
            <div class="mymenutoolbar">
                <mat-panel-title class="title">
                    Your Custom Menu
                </mat-panel-title>
                <div class="mymenualign">
                    <button mat-icon-button>
                        <mat-icon class="btn-icon" (click)="download()">download</mat-icon>
                    </button>
                    <button mat-icon-button>
                        <mat-icon class="btn-icon">share</mat-icon>
                    </button>
                    <button mat-icon-button>
                        <mat-icon class="btn-icon">print</mat-icon>
                    </button>
                    <button mat-icon-button>
                        <mat-icon class="btn-icon">clear_all</mat-icon>
                    </button>
                </div>
            </div>
            <div id="print">
                <mat-accordion *ngFor="let item of selectedItems">
                    <div class="cardx">
                        <div class="left">
                            <mat-expansion-panel class="panel">
                                <mat-expansion-panel-header>
                                    <mat-panel-title>
                                        Item: {{selectedItems.indexOf(item)+1}} -- {{item.foodtype}} -- {{item.foodname}}
                                    </mat-panel-title>
                                </mat-expansion-panel-header>
                                <img mat-card-image [src]="item.image" alt="{{item.text}}" class="panelimage">

                            </mat-expansion-panel>
                        </div>
                        <div class="right">
                            <button mat-icon-button (click)="removeFromMenu(item)">
                                <mat-icon class="btn-iconwhite" inline="false">delete</mat-icon>
                            </button>
                        </div>
                    </div>
                </mat-accordion>
            </div>
        </div>
    </div>
</section>